import React from "react";
import { IFilters } from "../RunDetails";
import { Button } from "reactstrap";

interface MessageTimeColumnFilterProps {
    filters: IFilters;
    setFilters: React.Dispatch<React.SetStateAction<IFilters>>;
    setAppliedFilters: (value: React.SetStateAction<IFilters>) => void;
}

const MessageTimeColumnFilter: React.FC<MessageTimeColumnFilterProps> = ({ filters, setFilters, setAppliedFilters}) => {

    const handleClick = () => {
        const newFilters = { ...filters, ascending: !filters.ascending };

        setFilters(newFilters);
        setAppliedFilters(newFilters);
    };
    
    return (
        <Button type="button" onClick={handleClick} style={{ width: "100%" }}>
            {filters.ascending ? "Ascending" : "Descending"}
        </Button>
    );
};

export default MessageTimeColumnFilter;